// Utility function to format applicant data for resume display
export const formatResumeData = (currentApplicant) => {
  if (!currentApplicant) return null;

  const mostRecentResumeData = currentApplicant?.resumeData || {};
  const mostRecentResumeParsedData = mostRecentResumeData?.parsedResume || {};

  return {
    contactInfo: {
      firstName: currentApplicant?.firstName || "",
      lastName: currentApplicant?.lastName || "",
      email: currentApplicant?.email || "",
      altEmail: currentApplicant?.altEmail || "",
      phone: currentApplicant?.phone || "",
      altPhone: currentApplicant?.altPhone || "",
      addressLineOne: currentApplicant?.address1 || "",
      city: currentApplicant?.city || "",
      state: currentApplicant?.state || "",
      zipCode: currentApplicant?.zip || "",
      linkedin: mostRecentResumeParsedData?.linkedInUrl || "",
    },
    objective: mostRecentResumeParsedData.objective || "",
    jobHistory:
      mostRecentResumeParsedData.jobHistory?.map((job) => ({
        jobTitle: job.lastTitle || job.startingTitle || "",
        companyName: job.companyName || "",
        city: job.city || "",
        state: job.state || "",
        startDate: job.fromDate || "",
        endDate: job.toDate || "",
        responsibilities: job.duties || [],
      })) || [],
    education:
      mostRecentResumeParsedData.education?.map((edu) => ({
        degree: edu.degreeDiploma || "",
        institutionName: edu.schoolName || "",
        city: edu.city || "",
        state: edu.state || "",
        fieldOfStudy: edu.major || "",
        minor: edu.minor || "",
        startDate: edu.startYear ? `${edu.startYear}-01-01` : "",
        endDate: edu.endYear ? `${edu.endYear}-01-01` : "",
      })) || [],
    skillsData: {
      tags: mostRecentResumeData.tags || [],
      otherSkills: mostRecentResumeData.otherSkills || []
    },
    certifications: mostRecentResumeParsedData?.certifications || [],
    licenses:
      mostRecentResumeParsedData.licenses?.map((license) => ({
        name: license.licenseType?.value || license.licenseType || "",
        issuingAuthority: "",
        issueDate: "",
        licenseStatus: license.licenseStatus || "",
        licenseNumber: license.licenseNumber || "",
        expiryDate: license.licenseExpDate || "",
      })) || [],
    awards: mostRecentResumeParsedData.awards || [],
    portfolio: mostRecentResumeParsedData.portfolio || [],
    references: (mostRecentResumeParsedData.references || []).filter(
      ref => ref?.company && ref?.company?.trim() !== ''
    ),
    languages: mostRecentResumeParsedData.languages || [],
    industries: mostRecentResumeParsedData.industries || [],
    overallExperience: mostRecentResumeParsedData.overAllExperience || { years: 0, months: 0 },
    jobTitle: mostRecentResumeParsedData.jobTitle || "",
  };
};
